import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class LiveRegionService {
  private liveElement: HTMLElement | null = null;
  private clearTimer: any = null;

  constructor(@Inject(DOCUMENT) private document: Document) {}

  toggleMainLiveRegion(off: boolean): void {
    this.document?.getElementById('main-content')
      ?.setAttribute('aria-live', off ? 'off' : 'polite');
  }

  /**
   * Announces a message to assistive technology (screen readers) via an offscreen live region.
   * Clears the message after durationMs (default 3000ms).
   */
  announce(message: string, durationMs: number = 3000): void {
    this.ensureLiveElement();
    if (!this.liveElement) {
      return;
    }

    if (this.clearTimer) {
      clearTimeout(this.clearTimer);
    }

    // Set text to empty first so consecutive identical announcements are voiced
    this.liveElement.textContent = '';
    setTimeout(() => {
      if (this.liveElement) {
        this.liveElement.textContent = message;
      }
    }, 50);

    this.clearTimer = setTimeout(() => {
      if (this.liveElement) {
        this.liveElement.textContent = '';
      }
    }, durationMs);
  }

  announceFiltersApplied(): void {
    this.announce('Filters applied');
  }

  announceFiltersCleared(): void {
    this.announce('Filters cleared');
  }
  announceFiltersRefreshed(): void {  
  this.announce('Filters refreshed');
  }

  private ensureLiveElement(): void {
    if (!this.liveElement && this.document?.body) {
      this.liveElement = this.document.getElementById('app-live-region');
      if (!this.liveElement) {
        this.liveElement = this.document.createElement('div');
        this.liveElement.id = 'app-live-region';
        this.liveElement.setAttribute('role', 'status');
        this.liveElement.setAttribute('aria-live', 'polite');
        this.liveElement.setAttribute('aria-atomic', 'true');
        this.liveElement.className = 'k-sr-only';
        this.document.body.appendChild(this.liveElement);
      }
    }
  }
}